var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{ref:"form"},[_c('group-builder',{attrs:{"item":_vm.objectModel,"queryType":_vm.queryType},on:{"sendQuery":_vm.sendPost}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }